export default __webpack_public_path__ + "static/media/w_f_2024_a.6f4c8438.jpg";